module.exports = __webpack_public_path__ + "img/status-rank.a6461fa8.png";